import React, { useState } from 'react';

import PropTypes from 'prop-types';
import Button from '@tds/core-button';

import { useLocalizedStringsContext } from '../../context/LocalizedStringsContext';
import { ConfirmationContainer, ConfirmationMessage } from './css';
import getFormattedPrice from '../util';

const ServiceListRow = ({ rowData, setEditService, removeService, index }) => {
  const localizedStrings = useLocalizedStringsContext();
  const {
    formButtons: {
      deleteButtonLabel,
      cancelButtonLabel,
      editButtonLabel,
      confirmButtonLabel
    },
    callCentre: { deleteConfirmationText }
  } = localizedStrings;

  const { id, name, paymentType, price, quantity } = rowData;
  const [isDelete, setIsDelete] = useState(false);
  return (
    <>
      {isDelete ? (
        <tr>
          <td colSpan="6">
            <ConfirmationContainer>
              <ConfirmationMessage>
                {deleteConfirmationText}
              </ConfirmationMessage>
              <Button onClick={() => removeService(id)}>
                {confirmButtonLabel}
              </Button>
              <Button
                variant="secondary"
                onClick={() => {
                  setIsDelete(false);
                }}
              >
                {cancelButtonLabel}
              </Button>
            </ConfirmationContainer>
          </td>
        </tr>
      ) : (
        <tr>
          <td width="10%">{index + 1}</td>
          <td width="40%">{name}</td>
          <td width="15%">{paymentType}</td>
          <td width="10%">{getFormattedPrice(price)}</td>
          <td width="10%">{quantity}</td>
          <td width="20%">
            <button
              type="button"
              className="btn btn-link"
              style={{ color: '#4B286D' }}
              onClick={() => setIsDelete(true)}
            >
              {deleteButtonLabel}
            </button>
            |
            <button
              type="button"
              className="btn btn-link"
              style={{ color: '#4B286D' }}
              onClick={() => setEditService(id)}
            >
              {editButtonLabel}
            </button>
          </td>
        </tr>
      )}
    </>
  );
};

ServiceListRow.propTypes = {
  rowData: PropTypes.arrayOf(PropTypes.any).isRequired,
  setEditService: PropTypes.func.isRequired,
  removeService: PropTypes.func.isRequired,
  index: PropTypes.number.isRequired
};

export default ServiceListRow;
